import { z } from "zod";
import { CheckSeveritySchema } from "./quality-gate-result.js";
export const ReportCheckDispositionSchema = z.enum([
    "PASSED",
    "FAILED",
    "WARNING",
    "SKIPPED",
    "DISABLED",
    "UNRESOLVED",
    "MANAGER_EXCEPTION",
    "NOT_RUN",
]);
export const ReportCheckSummaryV1Schema = z
    .object({
    schemaVersion: z.literal("report-check-summary.v1.0"),
    checkId: z.string().min(1),
    disposition: ReportCheckDispositionSchema,
    severity: CheckSeveritySchema.optional(),
    clientSafeMessage: z.string().min(1).optional(),
    internalDetail: z.string().min(1).optional(),
})
    .strict();
export const ReportCoverageSummaryV1Schema = z
    .object({
    schemaVersion: z.literal("report-coverage-summary.v1.0"),
    checksTotal: z.number().int().nonnegative(),
    checksPassed: z.number().int().nonnegative(),
    checksFailed: z.number().int().nonnegative(),
    checksSkipped: z.number().int().nonnegative(),
    checksDisabled: z.number().int().nonnegative(),
    checksUnresolved: z.number().int().nonnegative(),
    checksManagerException: z.number().int().nonnegative(),
    checksNotRun: z.number().int().nonnegative(),
    checksWarning: z.number().int().nonnegative(),
    coveragePercent: z.number().min(0).max(100),
    allowsFullPassLanguage: z.boolean(),
})
    .strict();
//# sourceMappingURL=report-check-summary.js.map